<template>
  <div class="md-layout text-center">
    <div
      class="
        md-layout-item
        md-size-33
        md-medium-size-50
        md-small-size-70
        md-xsmall-size-100
      "
    >
    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="this.show_message">
      <strong>Congratulation!</strong> A message with a reset password link has been sent to your email address. Please open the link to set your new password.
    </div><br>
      <login-card header-color="green">
        <h4 slot="title" class="title">Forget Password</h4>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <div slot="footer">
          <md-button class="md-success" v-on:click="SendForgetPasswordLink()" :disabled="isDisabled">
            Send Reset Password Link
          </md-button>  
          <hr>
          <a class="fs-12" href="javascript:void(0)" @click="$router.push('/login')">Login</a>
        </div>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import UserDataService from "../../../services/UsersDataService";
export default {
  components: {
    LoginCard,
  },
  data() {
    return {
      email: null,
      show_message: false,
      isDisabled: false,
    };
  },
  methods: {
    SendForgetPasswordLink() {
        this.isDisabled = true;
        var data = {
            email: this.email,
        };
        UserDataService.SendForgetPasswordLink(data)
            .then((response) => {
                this.isDisabled = false;
                this.$toast.success(response.data.respones_msg);
                this.email = null;
                this.show_message = true;
            })
            .catch((e) => {
                this.isDisabled = false;
                this.$toast.error(e.response.data.respones_msg);
            });
    },
  },
  beforeMount() {
    
  },
};
</script>

<style>
.fs-12{
  font-size: 16px !important;
  font-weight: 400;
  color: mediumblue !important;
}
</style>
